import { COMMAND_PRIORITY_NORMAL, PASTE_COMMAND } from 'lexical';
import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { eventFiles } from '@lexical/rich-text';

type PastedFilesPluginProps = {
  onPastedFiles: (files: File[]) => void;
};

export const PastedFilesPlugin: React.FC<PastedFilesPluginProps> = ({
  onPastedFiles,
}) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      payload => {
        const [hasFiles, files] = eventFiles(payload);
        if (hasFiles) {
          onPastedFiles(files);
          return true;
        }
        return false;
      },
      COMMAND_PRIORITY_NORMAL,
    );
  }, [editor, onPastedFiles]);

  return null;
};
